// extracted by mini-css-extract-plugin
module.exports = {"Platform":"Platform_Platform__1etwc"};